var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-wrapper",class:{ large: _vm.size === 'large' },on:{"click":_vm.routeToBrandDetail}},[_c('img',{style:({ width: _vm.item.image ? '' : '170px' }),attrs:{"src":_vm.item.image ? _vm.item.image : require('@/assets/images/no-image-small.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }